import {jsclj, resolveGoogExport} from 'dgetz/tsclj'

interface PrimaryProps {
    children: any;
    fullWidth?: boolean;
    onClick: Function;
    roundedCorners?: boolean;
    loading?: boolean;
    disabled?: boolean;
    className?: string;
    name?: string;
    textTransformDisabled?: boolean;
    backgroundColor?: string;
}
export function Primary ({children, fullWidth, onClick, roundedCorners, loading, disabled, className, textTransformDisabled, backgroundColor} : PrimaryProps) {
    let {primary} = resolveGoogExport('ladder.ux.button');
    return primary(jsclj({
        "class": className,
        "full-width?": fullWidth,
        "on-click": onClick,
        "rounded-corners?": roundedCorners,
        "loading?": loading,
        "disabled?": disabled,
        "text-transform-disabled?": textTransformDisabled,
        "background-color": backgroundColor}), children);
}
